"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformResponseChargebeePeriodUnit = exports.SdPlatformResponseChargebeeCurrencyCode = void 0;
var SdPlatformResponseChargebeeCurrencyCode;
(function (SdPlatformResponseChargebeeCurrencyCode) {
    SdPlatformResponseChargebeeCurrencyCode["USD"] = "USD";
    SdPlatformResponseChargebeeCurrencyCode["AUD"] = "AUD";
    SdPlatformResponseChargebeeCurrencyCode["EUR"] = "EUR";
    SdPlatformResponseChargebeeCurrencyCode["GBP"] = "GBP";
})(SdPlatformResponseChargebeeCurrencyCode = exports.SdPlatformResponseChargebeeCurrencyCode || (exports.SdPlatformResponseChargebeeCurrencyCode = {}));
var SdPlatformResponseChargebeePeriodUnit;
(function (SdPlatformResponseChargebeePeriodUnit) {
    /**
     * Charge based on day(s).
     */
    SdPlatformResponseChargebeePeriodUnit["Day"] = "day";
    /**
     * Charge based on week(s).
     */
    SdPlatformResponseChargebeePeriodUnit["Week"] = "week";
    /**
     * Charge based on month(s).
     */
    SdPlatformResponseChargebeePeriodUnit["Month"] = "month";
    /**
     * Charge based on year(s).
     */
    SdPlatformResponseChargebeePeriodUnit["Year"] = "year";
})(SdPlatformResponseChargebeePeriodUnit = exports.SdPlatformResponseChargebeePeriodUnit || (exports.SdPlatformResponseChargebeePeriodUnit = {}));
//# sourceMappingURL=SdPlatformResponseChargebee.js.map